export const EXPLORE_LOADING = 'EXPLORE_LOADING';
export const EXPLORE_FULFILLED = 'EXPLORE_FULFILLED';
export const EXPLORE_DETAIL_FULFILLED = 'EXPLORE_DETAIL_FULFILLED';
export const EXPLORE_RESET_SEARCH = 'EXPLORE_RESET_SEARCH';
export const EXPLORE_EMPTY_DATA = 'EXPLORE_EMPTY_DATA';
export const EXPLORE_SEARCH = 'EXPLORE_SEARCH';
export const EXPLORE_RELATED_FULFILLED = 'EXPLORE_RELATED_FULFILLED';
export const EXPLORE_CATEGORY_RELATED_FULFILLED = 'EXPLORE_CATEGORY_RELATED_FULFILLED';
